/**
 * Build the GCS V4 signed POST multipart body.
 * Policy fields must be appended before `file`. Do not set a manual
 * multipart Content-Type header — the runtime supplies the boundary.
 */

export function buildSignedPostUploadForm({ fields, file } = {}) {
  const form = new FormData();
  if (fields && typeof fields === 'object' && !Array.isArray(fields)) {
    for (const [key, value] of Object.entries(fields)) {
      if (value == null) continue;
      form.append(key, value);
    }
  }
  form.append('file', file);
  return form;
}

export function signedPostUploadFetchInit(form) {
  return {
    method: 'POST',
    body: form,
  };
}

export function formDataKeys(form) {
  return [...form.keys()];
}
